import { Box } from '@jfs/ui-new'
import { useState } from 'react'
import { DefaultInnerComp } from './DefaultInnerComp'

const inputBoxConfig = () => ({
  element: document.createElement('input'),
  type: 'file',
})

interface FileSelectorProps {
  onFileSelect: any
  InnerComp?: any
  fileType?:
    | '.csv'
    | '.doc'
    | '.xlsx'
    | '.xls,.xlsx,.xlsb'
    | '.png'
    | '.xls,.xlsx,.xlsb,.doc,.docx,.pdf,.jpg,.jpeg,.png'

  innerCompTitle?: string
  innnerCompSubtitle?: string
  filename?: string
  isLoading?: boolean
  onCancelPress?: any
  percent?: number | string
  fileId?: string
  showRemoveFile?: boolean
  showToast?: any
  onDismiss?: any
}

const FileSelector = ({
  onFileSelect,
  InnerComp = DefaultInnerComp,
  fileType = '.csv',
  innerCompTitle,
  innnerCompSubtitle,
  filename,
  onCancelPress,
  isLoading,
  percent,
  fileId,
  showRemoveFile,
  showToast,
}: FileSelectorProps) => {
  const [error, setError] = useState('')
  const onDragStart = (e: any) => {
    setError('')
    e.preventDefault()
  }

  const onDragOver = (e: any) => {
    setError('')
    e.preventDefault()
  }

  const onDrop = (e: any) => {
    setError('')
    e.preventDefault()
    const fileChosen = (e.dataTransfer.files as FileList)[0]
    if ((fileChosen?.name.match(/\./g) || []).length > 1) {
      setError('Invalid file')
    } else if (fileType?.includes(',') && fileType?.split(',')?.length > 0) {
      if (fileType?.split(',')?.includes(`.${fileChosen?.name?.toLowerCase()?.split('.')?.[1]}`)) {
        onFileSelect(fileChosen, fileChosen?.name ?? '', fileChosen?.size ?? 0)
      } else {
        setError('Invalid file')
      }
    } else {
      if (fileChosen?.name?.toLowerCase()?.includes(fileType)) {
        onFileSelect(fileChosen, fileChosen?.name ?? '', fileChosen?.size ?? 0)
      } else {
        setError('Invalid file')
      }
    }
  }

  const onFileSelected = (e: Event): void => {
    const target = e.target as HTMLInputElement
    const fileChosen = (target.files as FileList)[0]
    if ((fileChosen?.name.match(/\./g) || []).length > 1) {
      setError('Invalid file')
    } else if (fileType?.includes(',') && fileType?.split(',')?.length > 0) {
      if (fileType?.split(',')?.includes(`.${fileChosen?.name?.toLowerCase().split('.')?.[1]}`)) {
        onFileSelect(fileChosen, fileChosen?.name ?? '', fileChosen?.size ?? 0)
      } else {
        setError('Invalid file')
      }
    } else {
      //single fileType case without comma
      if (fileChosen?.name?.toLowerCase()?.includes(fileType)) {
        onFileSelect(fileChosen, fileChosen?.name ?? '', fileChosen?.size ?? 0)
      } else {
        setError('Invalid file')
      }
    }
  }

  const selectFileButtonPressed = (): void => {
    const inputBoxConfigTemp = inputBoxConfig()
    const inputBox = inputBoxConfigTemp.element
    inputBox.type = inputBoxConfigTemp.type
    inputBox.accept = fileType
    inputBox.draggable = true
    inputBox.click()
    inputBox.onchange = onFileSelected
    setError('')
  }

  return (
    <div draggable={true} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop}>
      <Box onPress={selectFileButtonPressed} testID={'selectFileToUpload'} underlayColor="TRANSPARENT">
        <InnerComp
          onCancelPress={onCancelPress}
          filename={filename}
          isLoading={isLoading}
          innnerCompSubtitle={innnerCompSubtitle}
          innerCompTitle={innerCompTitle}
          percent={percent}
          fileId={fileId}
          showRemoveFile={showRemoveFile}
          error={error}
        />
      </Box>
    </div>
  )
}

export { FileSelector }
